import gql from 'graphql-tag'

export const QuizzFragment = gql`
  fragment QuizzFragment on Quiz {
    id
    daily_physical_activity
    daily_physical_activity_reached
    intense_physical_activity
    intense_physical_activity_reached
    screen_time
    screen_time_reached
    recommendation_profile
    physical_profile
    recommendations {
      id
      title
      type
      image
      url
    }
    texts {
      recommendation
      physical_activity
    }
    created_at
  }
`
